export const RESOURCE_PATH = 'learning-resources';
export const RESOURCE_PUBLIC_CONTENT_PATH = 'resource-assets';
export const CONTENT_PATH = 'content-assets';
export const MEDIA_LIBRARY_PATH = 'media';
export const SCHOOL_DASHBOARD_PATH = 'school-dashboard';
export const TEXT_SPEECH_PATH = 'text-speeches';
export const PROGRAM_CONTENT_PATH = 'program-content';
